import { PageRouting } from './PageRouting/Index';
import "./App.css";
import { Buffer } from "buffer";
if (!window.Buffer) window.Buffer = Buffer;

function   App() {
  return (
    <PageRouting />
  );
}

export default App;
